export default "__VITE_ASSET__CvMT$pTk__"